import React from 'react';
import './App.css';
import Header from './components/header/Header';
import Body from './components/body/Body';

const App = () => {
  return (
    <div id="content">
      <Header/>
      <Body/>
    </div>
      
  );
}

export default App;
